<template>
  <product-shipping-methods ref="shippingMethodsRef" />
</template>

<script lang="ts" setup>
const shippingMethodsRef = ref()

defineExpose({
  method: computed(() => shippingMethodsRef.value?.method)
})
</script>
